import { HTTP_METHODS } from '@studio/constants/axios';
import { subtitlesApiUrl } from '@studio/constants/env-variables';
import type { Subtitles } from '@studio/types';

export const id = {
  [HTTP_METHODS.PATCH]: {
    url: `${subtitlesApiUrl}/words-by-video/@customerId/video/@id`,
    method: HTTP_METHODS.PATCH,
    params: {} as { id: string },
    request: [] as Subtitles.Patch.Word[],
  },
};
